import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import ScrollToTopProgress from "./ScrollToTopProgress";
import ChatLauncher from "./ChatLauncher";
import ChatPanel from "./ChatPanel";

export default function FloatingActions() {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <>
      {/* FLOATING BUTTON STACK */}
      {!chatOpen && (
        <div
          className="
            fixed z-50
            right-4 bottom-4
            flex flex-col gap-3
            max-sm:gap-2
            max-sm:right-3
            max-sm:bottom-[calc(env(safe-area-inset-bottom)+12px)]
          "
        >
          <ChatLauncher onOpen={() => setChatOpen(true)} />
          <ScrollToTopProgress />
        </div>
      )}

      {/* CHAT PANEL */}
      <AnimatePresence>
        {chatOpen && <ChatPanel onClose={() => setChatOpen(false)} />}
      </AnimatePresence>
    </>
  );
}
